<div class="grid grid-liquid home-policy">
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-claim-small" class="xsmall"></open-svg-icon>
      <h2>Cover</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Start</span>
        <span class="stat-block-value">{{ policyDetails.startDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">End</span>
        <span class="stat-block-value">{{ policyDetails.endDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Payment frequency</span>
        <span class="stat-block-value">{{ policyDetails.paymentFrequency.label }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Premium</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.premium" size="inherit"></open-price> (Inc GST)</span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.extras?.length">
        <span class="stat-block-title">Optional extras</span>
        <ul>
          <li *ngFor="let extra of policyDetails.extras"><span class="stat-block-value">{{ extra.choice }}</span></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="house-home-small" class="xsmall"></open-svg-icon>
      <h2>Home</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-8 flex flex-column stat-block">
        <span class="stat-block-title">Address</span>
        <span class="stat-block-value">{{ policyDetails.isRaptorial ? policyDetails.address : (policyDetails.address | address) }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Excess</span>
        <span class="stat-block-value" *ngIf="policyDetails.hasBuilding">Home: <open-price [price]="policyDetails.excess.building" [precision]="0" size="inherit"></open-price></span>
        <span class="stat-block-value" *ngIf="policyDetails.hasContents">Contents: <open-price [price]="policyDetails.excess.contents" [precision]="0" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Sum insured</span>
        <span class="stat-block-value" *ngIf="policyDetails.hasBuilding">Home: <open-price [price]="policyDetails.sumInsured.building" [precision]="0" size="inherit"></open-price></span>
        <span class="stat-block-value" *ngIf="policyDetails.hasContents">Contents: <open-price [price]="policyDetails.sumInsured.contents" [precision]="0" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.valuables?.length">
        <span class="stat-block-title">Valuables</span>
        <ul>
          <li *ngFor="let valuable of policyDetails.valuables"><span class="stat-block-value">{{ valuable.name }}: <open-price [price]="valuable.value" [precision]="0" size="inherit"></open-price></span></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-drivers-small" class="xsmall"></open-svg-icon>
      <h2>Policyholders</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-8 flex flex-column stat-block">
        <!-- There can be more than one primary policyholder due to a bug allowing multiple primaries to exist in the past -->
        <span class="stat-block-title">Primary policyholder{{ policyDetails.primaryPolicyHolder?.length > 1 ? 's' : '' }}</span>
        <div class="grid grid-large-8 margin-none">
          <div class="cell cell-large-col-span-4 flex flex-column" *ngFor="let policyholder of policyDetails.primaryPolicyHolder">
            <span class="stat-block-value">{{ policyholder.first_name }} {{ policyholder.last_name }}</span>
            <span class="stat-block-desc">{{ policyholder.gender | gender }},  {{ policyholder.dob | age }}</span>
          </div>
        </div>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.additionalPolicyholders?.length">
        <span class="stat-block-title">Additional policyholders</span>
        <div class="grid grid-large-8 margin-none">
          <div class="cell cell-large-col-span-4 flex flex-column" *ngFor="let policyholder of policyDetails.additionalPolicyholders">
            <span class="stat-block-value">{{ policyholder.first_name }} {{ policyholder.last_name }}</span>
            <span class="stat-block-desc">{{ policyholder.gender | gender }},{{ policyholder.dob | age }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box" *ngIf="policyDetails.authorisedPersons?.length">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-authoriseddrivers-small" class="xsmall"></open-svg-icon>
      <h2>Authorised contacts</h2>
    </div>
    <div class="cell cell-large-col-span-8 flex flex-column stat-block">
      <span class="stat-block-title">Authorised contact</span>
      <div class="grid grid-large-8 margin-none">
        <div class="cell cell-large-col-span-4 flex flex-column" *ngFor="let person of policyDetails.authorisedPersons">
            <span class="stat-block-value">{{ person.first_name || person.other_authorised_contact_given_name }} {{ person.last_name || person.other_authorised_contact_last_name }}</span>
            <span class="stat-block-desc">{{ (person.dob || person.other_authorised_contact_dob) | displayDate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
